import { AppAbilityType } from '../../../components/ability/ability';

const VIEW_NAVIGATION = {
    SITES: '/sites',
    NOMINATIONS: '/nominations',
    READINESS_TRACKING: '/nomination-readiness-tracking',
};

export const siteViewInterface = (userAbility: AppAbilityType) =>
    userAbility.can('view-route', '/sites') && userAbility.can('view-route', '/nominations')
        ? [
              {
                  title: 'Sites',
                  value: VIEW_NAVIGATION.SITES,
                  tooltip: 'Sites',
                  isVisible: true,
              },
              {
                  title: 'Nominations',
                  value: VIEW_NAVIGATION.NOMINATIONS,
                  tooltip: 'Nominations',
                  isVisible: true,
              },
              {
                  title: 'Readiness Tracking',
                  value: VIEW_NAVIGATION.READINESS_TRACKING,
                  tooltip: 'Readiness Tracking',
                  isVisible: userAbility.can('view-route', '/nomination-readiness-tracking'),
              },
          ]
        : [];
